<template>
  <div class="detail_swiper">
    <div v-if='li.MediaType==0' class="x img">
      <img v-lazy="li.MediaUrl" class="van_img"/>
    </div>
    <div v-if='li.MediaType==1' class="x img">
      <video :name="'video' + currentIndex" :id="'video' + currentIndex" class="van_video"
             :poster="poster"
             autoplay='autoplay'
             x5-video-player-fullscreen="true"
             x5-playsinline
             playsinline
             webkit-playsinline
             preload="preload"
             loop="loop">
        <source :src="li.MediaUrl">
        您的浏览器不支持 video元素。
      </video>
    </div>
    <div class="custom-indicator">
      <div class="content">
        <div class="detail_title">{{li.Title}}</div>
        <div class="detail_desc">{{li.Intro}}</div>
      </div>
    </div>

  </div>
</template>
<script>
  export default {
    data(){
      return{
        li:null,
        src: 'http://user-guide-1256119282.file.myqcloud.com/register/1561096861226554100.mp4',
        currentIndex: 0, // 父级循环的index
        changeCurrent: 0, // swiper切换到的index
        poster:require('../assets/img/default.jpg')
      }
    },
    props:['lis', 'index', 'current'],

    watch:{
      lis:{
        handler(newName, oldName) {
          this.li=newName
          if(this.li.MediaType==1){
            // this.$refs.video.src=this.li.MediaUrl
            // this.src = this.li.MediaUrl

          }
        },
        deep: true,
        immediate: true
      },
      current () {
        this.changeCurrent = this.current
        this.videoPlay()
      }
    },
    mounted () {
      this.currentIndex = this.index
      this.$nextTick(() => {
        // let video0 = document.getElementById('video0')
        // video0 && video0.play()
      })
      this.videoPlay()
    },
    methods: {
      videoPlay () {
        let $video = document.getElementById('video' + this.changeCurrent)
        if ($video) {
          $video.play()
        }
      }

    }
  }
</script>
<style lang="scss" scoped>
  .detail_swiper{
    display: flex;
    flex-direction: column;
    .img{
      flex: 30rem;
    }
    .x{
      width: 100%;
      position: relative;
      overflow: hidden;
    }
    .van_img{
      height: 100%;
      min-height:26rem;
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
      max-width: 100%;
    }
    .van_video{
      height: 100%;
      min-height:26rem;
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
    }
    .custom-indicator{
      flex:auto;
      padding: 1.875rem 1.5rem 1rem;
      text-align: left;
      position: relative;
      .detail_title{
        font-size: 1.5rem;
        letter-spacing: 0;
        line-height: 1.5rem;
        margin-bottom: 1rem;
      }
      .detail_desc{
        font-size: 1rem;
        letter-spacing: 0;
        line-height: 1.5rem;
        max-height: 7.5rem;
        overflow: auto;
        white-space: pre-line;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/detailswipe.vue